import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";
import { isCaseScenarioId } from "../../lib/caseScenarios";
import { submittedCaseLine } from "./submittedCaseLine";

/** Short case title shown once the composer is hidden, matching Medical history. */
export default function SubmittedCaseSummary({ result, queryText, scenario = null }) {
  const { t } = useLanguage();
  const line = submittedCaseLine(result, queryText);
  const scenarioLabel = isCaseScenarioId(scenario)
    ? t("scenario.summaryLabel").replace("{name}", t(`scenario.${scenario}.name`))
    : "";
  return (
    <div
      className="rounded-md border border-border bg-card px-4 py-3"
      data-testid="submitted-case-summary"
    >
      {scenarioLabel ? (
        <p
          className="text-xs text-muted-foreground mb-1"
          data-testid="submitted-scenario-label"
        >
          {scenarioLabel}
        </p>
      ) : null}
      <p className="text-sm font-medium text-foreground">
        {line || t("history.aiSecondOpinion")}
      </p>
      <p className="text-xs text-muted-foreground mt-0.5">
        {t("history.source.medconcil_case")}
      </p>
    </div>
  );
}
